module.exports = __webpack_public_path__ + "media/images/twitterIcon-401ed706.svg";